<template>
  <zpa-form-group>
    <Button style="margin-left: 20px;" v-if="needUpload" @click="addOne()">添加其他附件</Button>
    <div style="position: relative;margin-left: 20px;" v-show="false">
      <Upload
          type="drag"
          :showUploadList="false"
          :action="picUrl"
          ref="uploadF"
          :accept="accept"
          :on-success="successHandle">
        <div style="padding: 5px 0;">
          <Icon type="ios-cloud-upload" size="18" style="color: #3399ff"></Icon>
          <p style="font-size: 12px">点击添加附件材料</p>
        </div>
      </Upload>
    </div>
    <DataList
        ref="attachmentTable"
        :index = false
        isHidePage
        :columns="columns"
        :oper-width="120"
        :query="getAttachMents"
    >
      <template slot-scope="row">
        <Button size="small"  @click="clickB(row.index,row.row.type)" v-if="needUpload">上传</Button>
        <Button size="small" type="error" @click="remove(fileList,row.index)" v-if="needUpload && (!row.row.isSys)">删除</Button>
      </template>
      <template slot-scope="{row}" slot="required">
        {{row.required?'是':'否'}}
      </template>
      <template slot-scope="{row}" slot="type">
        {{row.type?row.type:'*'}}
      </template>
      <template slot-scope="{row,index}" slot="fileList">
        <p v-for="(item,index2) in row.fileList">
          <a target="_blank" :href="item.fileSrc">{{item.fileName}}</a>
          <Button size="small" type="error" @click="remove(fileList[index].fileList,index2)" v-if="needUpload">删除</Button>
        </p>

      </template>
    </DataList>
  </zpa-form-group>

</template>

<script>
import { getPicUrl } from '@/api/cosfile/picUrl'
import { getFilePath } from '@/api/cosfile/cosfile'
export default {
  name: 'AttachInfoForm',
  data() {
    return {
      picSrc: '',
      picUrl: '',
      tempIndex:0,
      accept:"*",
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80
        },
        {
          title: '附件名称',
          key: 'fileName',
          width: 200
        },
        {
          title: '是否必填',
          key: 'required',
          align: 'center',
          width: 90
        },
        {
          title: '文件类型',
          key: 'type',
          align: 'center',
          width: 90
        },
        {
          title: '已上传文件',
          key: 'fileList',
        },
      ],
    }
  },
  mounted() {
    this.picUrl = getPicUrl()
    this.loadData()
  },
  props: {
    fileList: {type: Array, default: () => []},
    needUpload: { type: Boolean, default: true },
  },
  methods: {
    clickB(index,accept){
      if(accept){
        this.accept = accept
      }else {
        this.accept = "*"
      }
      this.tempIndex = index
      setTimeout(() =>{
        this.$refs.uploadF.handleClick()
      },100)
    },
    successHandle: function (response, file, fileList) {
      const temp = {
        fileName: file.name,
        fileSrc: getFilePath(response.key)
      }
      this.fileList[this.tempIndex].fileList.push(temp)
    },
    getAttachMents() {
      const d = {objList: this.fileList}
      return d
    },
    remove(target,index) {
      target.splice(index, 1);
    },
    addOne(){
      const oneData ={
        nodeCode:"",
        nodeName: "",
        fileName: "其他附件",
        required: false,
        type: "*",
        isSys: false,
        fileList: []
      }
      this.fileList.push(oneData)
    },
    loadData() {
      this.$refs['attachmentTable'].load({})
    }
  }
}
</script>
